import { type MetaDescriptor } from 'react-router'

// Shared by the root route meta (root/meta.ts) and the static fatal-error
// document (entry.server), which has no React Router context and needs plain HTML.
export const FAVICON_LINKS = [
  {
    tagName: 'link',
    rel: 'shortcut icon',
    href: '/favicon.ico',
  },
  {
    tagName: 'link',
    rel: 'apple-touch-icon',
    sizes: '180x180',
    href: '/apple-touch-icon.png',
  },
  {
    tagName: 'link',
    rel: 'icon',
    sizes: '32x32',
    href: '/favicon-32x32.png',
    type: 'image/png',
  },
  {
    tagName: 'link',
    rel: 'icon',
    sizes: '16x16',
    href: '/favicon-16x16.png',
    type: 'image/png',
  },
  {
    tagName: 'link',
    rel: 'mask-icon',
    color: '#5bbad5',
    href: '/safari-pinned-tab.svg',
  },
] as const satisfies readonly MetaDescriptor[]

export function faviconLinksToHtml(): string {
  return FAVICON_LINKS.map(({ tagName, ...attrs }) => {
    const attrsHtml = Object.entries(attrs)
      .map(([name, value]) => `${name}="${value}"`)
      .join(' ')
    return `<${tagName} ${attrsHtml}>`
  }).join('')
}
